import React, { useState, useEffect, useContext } from "react";
import AddBatch from '../components/Batches/AddBatch';
import AuthContext from "../AuthContext";
import AllBatches from '../components/Batches/AllBatches';
import UpdateBatch from '../components/Batches/UpdateBatch';
import Breadcrumbs from'../components/Breadcrumbs';

function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [searchTerm, setSearchTerm] = useState();
  const [updatePage, setUpdatePage] = useState(true);
  const [refreshPage, setRefreshPage] = useState(false);
  const [batch, setBatch] = useState('');
  const authContext = useContext(AuthContext);

  // Modal for Batch ADD
  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  // Modal for Batch UPDATE
  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };

  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
    setRefreshPage(!refreshPage); // Trigger a refresh
  };


  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        
        {/* Add Batch Modal */}
        {showProductModal && (authContext.userType !== 'Trainer'||authContext.userType!=='Accounts') && (
          <AddBatch
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}

        {/* Update Batch Modal */}
        {showUpdateModal && (authContext.userType !== 'Trainer'||authContext.userType!=='Accounts') &&  (
          <UpdateBatch
            updateProductData={updateProduct}
            handlePageUpdate={handlePageUpdate}
            updateModalSetting={updateProductModalSetting}
          />
        )}

        {/* Table */}
        <div className="overflow-x-auto rounded-md bg-white border border-gray-200 shadow-lg">
          <div className="flex justify-between p-4 bg-gray-100 border-b border-gray-200">
            <h2 className="font-bold text-lg text-gray-700">Batches</h2>
           {(authContext.userType==='Superadmin'
           ||authContext.userType==='Admin'
           ||authContext.userType==='Manager')&&
            <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 text-sm rounded-sm shadow-md transition duration-300"
            onClick={addProductModalSetting}
          >
            Add Batch 
          </button>
           }
          </div>
          <AllBatches 
            updateProductModalSetting={updateProductModalSetting} 
            handlePageUpdate={handlePageUpdate} 
          />
        </div>
      </div>
    </div>
  );
}

export default Inventory;
